import axios from "axios";

export interface PaymentData {
  name: string;
  email: string;
  amount: number;
  phoneNumber: string;
  occupancyDates: string[];
}

let API_BASE_URL = process.env.API_BASE_URL || "https://www.parknfly.lt:3443";
// let API_BASE_URL = process.env.API_BASE_URL || "https://localhost:3001";


export const createOrder = async (orderData: any) => {
  const response = await axios.post(`${API_BASE_URL}/create-order`, orderData);
  return response.data;
};
